import {
  resetURLParams,
  addURLParams
} from 'common/utils';

import { URL_PARAMS } from '../constants';

export const deleteURLParamActiveStation = () => {
  resetURLParams([URL_PARAMS.activeStation]);
}

export const addURLParamActiveStation = (value: string) => {
  addURLParams({ [URL_PARAMS.activeStation]: value });
};